import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Slug aliases that map common high-intent UK search queries to the
 * canonical product page. Each alias is on the sitemap and carries a
 * distinct UTM so we can attribute traffic in GA later.
 *
 * SEO play: instead of building 5 separate landing pages, we land
 * search-intent traffic directly on the converting product page,
 * pre-qualified by the slug. Each alias is `noindex` (the canonical
 * /products/{id} URL absorbs the link equity, no duplicate content).
 *
 * Lighter touch than a dedicated landing page — better for "Buy ..."
 * commercial-intent queries that should go straight to checkout, not
 * an explainer page.
 */

const PRODUCT_ID = '94056720-f372-4eef-bcfe-74063137a6e5';

export default function ProductSlugRedirect({ utmCampaign }) {
  const navigate = useNavigate();
  useEffect(() => {
    // noindex so this thin alias doesn't compete with the canonical URL
    const m = document.createElement('meta');
    m.setAttribute('name', 'robots');
    m.setAttribute('content', 'noindex, follow');
    document.head.appendChild(m);
    const utm = `utm_source=organic&utm_medium=slug&utm_campaign=${encodeURIComponent(utmCampaign)}`;
    navigate(`/products/${PRODUCT_ID}?${utm}`, { replace: true });
    return () => {
      try { document.head.removeChild(m); } catch (e) { /* ignore */ }
    };
  }, [navigate, utmCampaign]);
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center">
        <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-emerald-700 mb-3">Loading product…</div>
        <p className="text-slate-600">Taking you to BCM-95<sup>&reg;</sup>.</p>
      </div>
    </div>
  );
}
